import { render, staticRenderFns } from "./officialAccount.vue?vue&type=template&id=761b9478&"
import script from "./officialAccount.vue?vue&type=script&lang=js&"
export * from "./officialAccount.vue?vue&type=script&lang=js&"
import style0 from "./officialAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports